import { render, staticRenderFns } from "./generalDetails.vue?vue&type=template&id=46bf6f77&scoped=true&"
import script from "./generalDetails.vue?vue&type=script&lang=js&"
export * from "./generalDetails.vue?vue&type=script&lang=js&"
import style0 from "./generalDetails.vue?vue&type=style&index=0&id=46bf6f77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bf6f77",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
